export const withTrailingSlash = (rawText: string) => {
  const text = rawText?.trim();

  if (!text || text.length === 0) {
    return text;
  }

  return hasTrailingSlash(text) ? text : text + SLASH;
};

export const hasTrailingSlash = (text: string): boolean => text?.[text?.length - 1] === SLASH;

const SLASH = "/";
